import React, { useCallback, useEffect, useState } from "react";
import { Card, Form, InputNumber, Typography, message } from "antd";
import SapaHeader from "../../ui/Header/Header";
import ProgressLoader from "../../components/Loader/ProgressLoader";
import SapaButton from "../../ui/Button/Button";
import { getCryptoUsdRateRequest, updateCryptoUsdRateRequest } from "../../api/management";

const CryptoUsdRate = () => {
  const [form] = Form.useForm();
  const [rateInfo, setRateInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const fetchRate = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await getCryptoUsdRateRequest();
      const payload = response?.data?.data || {};
      setRateInfo(payload);
      form.setFieldsValue({ conversion_rate: Number(payload?.conversion_rate || 0) });
    } catch (error) {
      message.error(error?.response?.data?.message || "Unable to load USD rate.");
    } finally {
      setIsLoading(false);
    }
  }, [form]);

  useEffect(() => {
    fetchRate();
  }, [fetchRate]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      setIsSaving(true);
      const response = await updateCryptoUsdRateRequest(values);
      message.success(response?.data?.message || "USD rate updated.");
      fetchRate();
    } catch (error) {
      message.error(error?.response?.data?.message || error?.message || "Unable to update USD rate.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <ProgressLoader isLoading={isLoading || isSaving}>
      <div className="Management crypto-usd-rate">
        <SapaHeader page="USD Rate" />
        <Card className="crypto-usd-rate__card">
          <div>
            <Typography.Text type="secondary">Current USD to NGN rate</Typography.Text>
            <Typography.Title level={2}>
              ₦{Number(rateInfo?.conversion_rate || 0).toLocaleString("en-NG", { minimumFractionDigits: 2 })}
            </Typography.Title>
            <Typography.Text type="secondary">
              Applies to {rateInfo?.records_count || 0} crypto records.
            </Typography.Text>
          </div>

          <Form form={form} layout="vertical" className="crypto-usd-rate__form">
            <Form.Item
              label="New Conversion Rate"
              name="conversion_rate"
              rules={[{ required: true, message: "Enter the USD conversion rate." }]}
            >
              <InputNumber min={0} precision={2} />
            </Form.Item>
            <SapaButton label="Update Rate" loading={isSaving} disabled={isSaving} onClick={handleSave} />
          </Form>
        </Card>
      </div>
    </ProgressLoader>
  );
};

export default CryptoUsdRate;
